module.exports = __webpack_public_path__ + "static/media/categories_step_1_2.fe4e0648.svg";